import 'whatwg-fetch';
import getConfig from  '../aws-config';
import axios from 'axios';

let authHeaders = `Bearer ${localStorage.getItem('jwt')}`

export function rejectNon2xx(res: any) {
  if (res.ok) {
    const response = res.json();
    return response;
  } else {
    if(res.status === 502) {
      throw new Error('Something went wrong')
    } else if (res.status === 401) {
      console.log('401 error object: ', res, res.json());
    } else {
      console.log('Some error happend', res);
      throw new Error(res);
    }
  }
}

export function rejectNon2xxAsText(res: any) {
  if (res.ok) {
    const response = res.text();
    return response
  } else {
    if(res.status === 502) {
      throw new Error('Something went wrong')
    } else if (res.status === 401) {
      console.log('401 error object: ', res, res.json());
    } else {
      console.log('Some error happend', res);
      throw new Error(res);
    }
  }
}

let headers: any = {
  'Content-Type': 'application/json',
  'Authorization': authHeaders ? authHeaders : 'not yet set',
  'IdToken': localStorage.getItem('IdToken')
};

export const setHeaders = (h: any) => {
  headers = h;
  localStorage.removeItem('jwt');
  localStorage.setItem('jwt', h.Authorization);
  localStorage.removeItem('IdToken');
  localStorage.setItem('IdToken', h.IdToken);
}

export const getHeaders = (newHeaders?: any) => ({ ...headers, ...newHeaders });
const config = getConfig();

export let http = axios.create({
  baseURL: `${config.api_url}${config.api_version}/`,
  timeout: 59000,
  headers: getHeaders()
});

http.interceptors.request.use((req: any) => {
  if(req.status === 401) {
      console.log('GOT 401')
  }

  req.headers = getHeaders();
  // check if we have params
  const queryString = window.location.search;
  if(queryString) {
    const urlParams = new URLSearchParams(queryString);
    const onBehalfOf: any = urlParams.get('OnBehalfOf');
    localStorage.setItem('onBehalfOf', onBehalfOf)
  }
  const onBehalfOfUser = localStorage.getItem('onBehalfOf')
  req.headers = getHeaders({OnBehalfOf: onBehalfOfUser ? onBehalfOfUser : ''});
  
  if(req.url === 'issuers' && req.method === 'post') {
    req.headers['Authorization'] =  getConfig().http_authorization
  }

  return req;
}, (error) => {
  if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
  }
  return Promise.reject(error.message);
});


export let v1http = axios.create({
  baseURL: `${config.api_url}v1.1/`,
  timeout: 59000,
  headers: getHeaders()
});

v1http.interceptors.request.use((req: any) => {
  if(req.status === 401) {
      console.log('GOT 401')
  }

  req.headers = getHeaders();
  // check if we have params
  const queryString = window.location.search;
  if(queryString) {
    const urlParams = new URLSearchParams(queryString);
    const onBehalfOf: any = urlParams.get('OnBehalfOf');
    localStorage.setItem('onBehalfOf', onBehalfOf)
  }
  const onBehalfOfUser = localStorage.getItem('onBehalfOf')
  req.headers = getHeaders({OnBehalfOf: onBehalfOfUser ? onBehalfOfUser : ''});
  
  if(req.url === 'issuers' && req.method === 'post') {
    req.headers['Authorization'] =  getConfig().http_authorization
  }

  return req;
}, (error) => {
  if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
  }
  return Promise.reject(error.message);
});